<template>
  <div class="question-table" :class="{ 'list-drag': canDrag }">
    <Table @selection-change="selectChange" :data="questions" row-key="uuid" :fromDetail="fromDetail" />
  </div>
</template>

<script>
import Table from "./table.js";
import Sortable from "sortablejs";
export default {
  components: {
    Table
  },
  props: {
    examQuestionType: {
      type: String,
      default: ""
    },
    questionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    draggable: { type: Boolean, default: false },
    isFromDetail: {
      type:  Boolean,
      default: false
    }
  },
  data() {
    return {
      checkArray: [],
      questions: [],
      sort: null,
      fromDetail: false
    };
  },
  watch: {
    questionList() {
      this.questions = this.questionList.filter(
        ele => ele.examQuestionType == this.examQuestionType
      );
    },
    examQuestionType(val) {
      this.questions = this.questionList.filter(
        ele => ele.examQuestionType == val
      );
    }
  },
  computed: {
    // 使用计算属性在拖拽功能状态改变时做出相应操作
    canDrag() {
      this.rowDrop(this.draggable);
      return this.draggable;
    },
  },
  created() {
    this.fromDetail = this.isFromDetail;
  },
  methods: {
    selectChange(selections) {
      this.checkArray = selections;
    },
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        // 开启时创建新的Sortable对象
        const tbody = document.querySelector(
          ".question-table .el-table__body-wrapper tbody"
        );
        let that = this;
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            const currRow = that.questions.splice(oldIndex, 1)[0];
            that.questions.splice(newIndex, 0, currRow);
            that.$emit("sort", that.questions, that.examQuestionType);
          }
        });
      }
    }
  }
};
</script>
